const settings = {
    APP_URL: process.env.VUE_APP_URL,
    APP_HUB_URL: process.env.VUE_APP_HUB_URL,
}

export default settings
